// extracted by mini-css-extract-plugin
module.exports = {"call-to-action-button":"callToActionButton_call-to-action-button__1WtQq","delayed-rotate":"callToActionButton_delayed-rotate__1s_Gb"};